import { useState } from "react";
import { formatSouthAsianNumber } from "../../utils/utils";
import { GetTopDealersResponseType } from "../../types/dashboard";
import RankOne from "../../assets/images/rank-1.svg";

type Props = {
  topDealersData: GetTopDealersResponseType|undefined;
  isLoading: boolean;
};

const TopDealers = ({ topDealersData, isLoading }: Props) => {
  const [topDealersToShow, setTopDealersToShow] = useState(3);
  const [showMoreButton, setShowMoreButton] = useState(true);

  const toggleShowTopDealers = () => {
    if (showMoreButton) {
      setTopDealersToShow(topDealersData?.data.length || 0);
      setShowMoreButton(false);
    } else {
      setTopDealersToShow(3);
      setShowMoreButton(true);
    }
  };

  if (isLoading) {
    return (
      <div className="mt-3">
        <div className="h-[87px] bg-slate-100 w-full my-2"></div>
        <div className="h-[87px] bg-slate-100 w-full my-2"></div>
        <div className="h-[87px] bg-slate-100 w-full my-2"></div>
      </div>
    );
  }

  return (
    <div className="mt-3 flex flex-col">
      {topDealersData?.data
        ?.slice(0, topDealersToShow)
        ?.map((dealer, index) => (
          <div
            className={`flex justify-between py-4 ${
              index !==
                topDealersData.data.slice(0, topDealersToShow).length - 1 &&
              "border-solid border-b border-t-0 border-l-0 border-r-0 dark:border-[#3D4A5C] border-[#D7DFE9]"
            }`}
            key={index}
          >
            <div className="flex gap-2 items-center">
              <div>
                <img
                  src={dealer.merchant.profile.logoImage || ""}
                  className="w-12 h-12 rounded-full"
                  alt=""
                />
              </div>
              <div>
                <div className="dark:text-header text-others-table-header flex items-center gap-2">
                  <span>{dealer.merchant.name || ""}</span>

                  {index === 0 && (
                    <div>
                      <img src={RankOne} alt="Rank One" />
                    </div>
                  )}
                </div>
                <div className="text-body">
                  {dealer.merchant.dealerNo || ""}
                </div>
              </div>
            </div>
            <div className="flex gap-2 items-center">
              <div>
                <div className="text-[12px] dark:text-body text-others-table-header">
                  Value
                </div>
                <div className="dark:text-header text-body">
                  ৳{formatSouthAsianNumber(dealer.transaction.totalAmount)}
                </div>
              </div>
              <div>
                <div className="text-[12px] dark:text-body text-others-table-header">
                  Trx
                </div>
                <div className="dark:text-header text-body">
                  {dealer.transaction.totalTransactions}
                </div>
              </div>
            </div>
          </div>
        ))}

      <div
        className="flex justify-center font-semibold text-primary cursor-pointer"
        onClick={toggleShowTopDealers}
      >
        {showMoreButton ? "Show more" : "Show less"}
      </div>
    </div>
  );
};

export default TopDealers;
